// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Wallet2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Wallet2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.333 9.142v1.716a.856.856 0 0 1-.833.85h-1.633c-.9 0-1.725-.658-1.8-1.558-.05-.525.15-1.017.5-1.358a1.66 1.66 0 0 1 1.2-.5H17.5a.856.856 0 0 1 .833.85Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.058 12.958h-1.191c-1.584 0-2.917-1.191-3.05-2.708a2.932 2.932 0 0 1 .875-2.35 2.869 2.869 0 0 1 2.075-.858h1.291c.242 0 .442-.2.417-.442-.183-2.025-1.525-3.408-3.517-3.642a3.812 3.812 0 0 0-.625-.041h-7.5c-.233 0-.458.016-.675.05-2.125.266-3.491 1.85-3.491 4.116v5.834c0 2.3 1.866 4.166 4.166 4.166h7.5c2.334 0 3.942-1.458 4.142-3.683a.409.409 0 0 0-.417-.442Zm-6.225-4.833h-5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h5a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
}));
export default Wallet2Icon;